export default __webpack_public_path__ + "static/media/vault.e706f696.png";